var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.86 6.62C13.8771 6.48042 13.8645 6.33881 13.8232 6.2044C13.7818 6.07 13.7126 5.94583 13.62 5.84C13.5263 5.73333 13.4109 5.64784 13.2816 5.58922C13.1523 5.53059 13.012 5.50018 12.87 5.5H2.12998C1.98799 5.50018 1.84767 5.53059 1.71836 5.58922C1.58904 5.64784 1.47369 5.73333 1.37998 5.84C1.28738 5.94583 1.21814 6.07 1.17679 6.2044C1.13543 6.33881 1.12289 6.48042 1.13998 6.62L1.88998 12.62C1.91945 12.8639 2.03769 13.0884 2.22213 13.2507C2.40657 13.413 2.6443 13.5018 2.88998 13.5H12.13C12.3757 13.5018 12.6134 13.413 12.7978 13.2507C12.9823 13.0884 13.1005 12.8639 13.13 12.62L13.86 6.62Z",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.5V5C3 3.80653 3.47411 2.66193 4.31802 1.81802C5.16193 0.974106 6.30653 0.5 7.5 0.5C8.69347 0.5 9.83807 0.974106 10.682 1.81802C11.5259 2.66193 12 3.80653 12 5V5.5",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8.5V10.5",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8.5V10.5",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.7e4cabcb8eda67764d3b0e43036b0fd8.svg";
export { ForwardRef as ReactComponent };